/* eslint-disable no-console */
import { create } from 'zustand';

interface PersonaState {
    currentPersonaId: string | null;
    currentPersonaName: string | null;
    setCurrentPersonaId: (id: string) => void;
    setCurrentPersonaName: (name: string) => void;
}

export const usePersonaStore = create<PersonaState>((set) => {
    let storedPersonaId: string | null = null;
    let storedPersonaName: string | null = null;

    // Safely rehydrate state from localStorage
    try {
        const rawStoredPersonaId = localStorage.getItem('currentPersonaId');
        const rawStoredPersonaName = localStorage.getItem('currentPersonaName');

        storedPersonaId = rawStoredPersonaId && isValidJSON(rawStoredPersonaId) ? JSON.parse(rawStoredPersonaId) : null;
        storedPersonaName = rawStoredPersonaName && isValidJSON(rawStoredPersonaName) ? JSON.parse(rawStoredPersonaName) : null;
    } catch (error) {
        console.error("Error parsing persona data from localStorage:", error);
        storedPersonaId = null;
        storedPersonaName = null;
    }

    return {
        currentPersonaId: storedPersonaId,
        currentPersonaName: storedPersonaName,
        setCurrentPersonaId: (id: string) => {
            set({ currentPersonaId: id });
            localStorage.setItem('currentPersonaId', JSON.stringify(id)); // Persist state to localStorage
        },
        setCurrentPersonaName: (name: string) => {
            set({ currentPersonaName: name });
            localStorage.setItem('currentPersonaName', JSON.stringify(name)); // Persist state to localStorage
        },
    };
});

// Helper function to validate JSON strings
function isValidJSON(value: string): boolean {
    try {
        JSON.parse(value);
        return true;
    } catch {
        return false;
    }
}
